import { useEffect, useRef, useState } from "react";
import style from "./OperatorSelect.module.scss";
import cn from "classnames";
import { KyivstarSvg, LifecellSvg, VodafoneSvg } from "./svg";
import { EOperator } from "@interfaces/operator.enum";
import { ITariff } from "@interfaces/user/tariff";

export function OperatorSelect({
    value,
    setValue,
    listPosition = "bottom",
    dataList
}: {
    value: {
        operator: string;
        count: number;
    },
    setValue: (newValue: ITariff["free_proxies"][0]) => void,
    listPosition?: "top" | "bottom",
    dataList: ITariff["free_proxies"]
}) {
    const refContainer = useRef<HTMLDivElement | null>(null);

    const [isOpen, setIsOpen] = useState<boolean>(false);

    useEffect(() => {
        function handleClick(e: any) {
            if (!refContainer.current?.contains(e.target)) {
                setIsOpen(false);
            }
        }

        document.documentElement.addEventListener("click", handleClick);

        return () => {
            document.documentElement.removeEventListener("click", handleClick);
        };
    }, []);

    return (
        <div ref={refContainer} className="relative w-full">
            <div
                className={style.container}
                onClick={() => {
                    setIsOpen(state => !state)
                }}
            >
                <p className={style.label}>Оператор:</p>
                <div className={style.valueBox}>
                    <OperatorIcon operator={value.operator} />
                    <p className={style.selectValue}>{value.operator || "Не знайдено"}</p>
                </div>
                <svg className="shrink-0 select-none cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
                    <path d="M5.46967 6.53033C5.76256 6.82322 6.23744 6.82322 6.53033 6.53033L11.3033 1.75736C11.5962 1.46447 11.5962 0.989592 11.3033 0.696699C11.0104 0.403806 10.5355 0.403806 10.2426 0.696699L6 4.93934L1.75736 0.696699C1.46447 0.403806 0.989592 0.403806 0.696699 0.696699C0.403806 0.989593 0.403806 1.46447 0.696699 1.75736L5.46967 6.53033ZM5.25 5L5.25 6L6.75 6L6.75 5L5.25 5Z" fill="#838199" />
                </svg>
            </div>
            <div
                style={{
                    [listPosition === "bottom" ? "top" : "bottom"]: "calc(100% + 10px)"
                }}
                className={cn(style.listValues, isOpen && style.listValues_open)}
            >
                {
                    dataList.map((item, i) => {
                        return (
                            <div className="flex items-center  gap-[18px]">
                                <div
                                    className={cn(style.value, value.operator === item.operator && "bg-[#DCE1F5]")}
                                    onClick={() => {
                                        setValue(item);
                                        setIsOpen(false);
                                    }}
                                >
                                    <OperatorIcon operator={item.operator} />
                                    <p>{item.operator}</p>
                                </div>
                                {
                                    item.operator === EOperator.Kyivstar ? null : <img src="./image/lightning.png" alt="" />
                                }
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

function OperatorIcon({ operator }: { operator: string }) {
    if (operator?.toLocaleLowerCase() === EOperator.Kyivstar?.toLocaleLowerCase()) {
        return (
            <KyivstarSvg />
        )
    } else if (operator?.toLocaleLowerCase() === EOperator.Vodafone?.toLocaleLowerCase()) {
        return (
            <VodafoneSvg />
        )
    } else if (operator?.toLocaleLowerCase() === EOperator.lifecell?.toLocaleLowerCase()) {
        return (
            <LifecellSvg />
        )
    } else {
        return null
    }
}